import _ from 'lodash';
const nowSeconds = () => Math.round(Date.now() / 1000);
function nullthrows(value) {
    if (value == undefined) {
        throw new Error('Unexpected null');
    }
    return value;
}
function assertNever(_value) {
}
function isPromise(value) {
    return value != undefined && value.then != undefined && typeof value.then === 'function';
}
function notNull(value) {
    return value != undefined;
}
function zip(...arrays) {
    return _.zip(...arrays);
}
export const utils = {
    nowSeconds,
    nullthrows,
    assertNever,
    notNull,
    isPromise,
    zip,
};

//# sourceMappingURL=utils.js.map
